module.exports = __webpack_public_path__ + "img/img-agency.c68c0731.png";